module.exports = __webpack_public_path__ + "img/company22.fc56ad64.png";